import { API_ADDRESS } from "../../constants";

import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Customer } from '../../models/customer.model';



export interface MayHaveId {
    id: number; // you can use any type, number is just an example
}

@Injectable()
export class DbTable<T extends MayHaveId>
{


    protected _controllerName: string;

    constructor(public _http: HttpClient, public controllerName: string) {
        this._controllerName = controllerName;
    }

    public getList(startPos: number, length: number, searchText: string): Promise<T[]> {

        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
        
        let url = API_ADDRESS + `/${this._controllerName}/search/${startPos}/${length}`;

        if(searchText !=null && searchText !='')
        {
            url += `/${searchText}`;
        }

        return this._http.get(url, { headers : httpHeaders} )
        .pipe(
            map((result: any) => {
                let list: T[] = result;
             
                return list;

            })
        ).toPromise();
    }

    public getCount(searchText: string): Promise<number> {

        searchText += "";
        return this._http.get(API_ADDRESS + `/${this._controllerName}/count/${searchText}`)
        .pipe(
            map((result: any) => {
                let list: number = result;
                console.log(list);
                return list;

            })).toPromise();
    }

    public getItem(id: number) {
        return this._http.get(API_ADDRESS + `/${this._controllerName}/` + `${id}`)
        .pipe(
            map((result: any) => {
                //   console.log(result);
                return result;
            })).toPromise();
    }


    put(data: T): Promise<T> {

        console.log("Atualizando ");
        console.log(data);

        let body = data;
        //  let headerOptions =new Headers();
        if (data.id > 0) {
            const httpHeaders = new HttpHeaders();
            httpHeaders.set('Content-Type', 'application/json');
          return  this._http.put(API_ADDRESS + `/${this._controllerName}/${data.id}`, body, { headers : httpHeaders} )
           .pipe(
            map((result: any) => {
              
                return result;

            })).toPromise();
   

        }
        else {

            console.log("Adicionando");
            console.log(data);

            const httpHeaders = new HttpHeaders();
            httpHeaders.set('Content-Type', 'application/json');

            console.log("Registro:");
            console.log(data);
            return this._http.post(API_ADDRESS + `/${this._controllerName}`, body, {headers: httpHeaders})
            .pipe(map((result: T)=>result))
                .toPromise();
       
        }

    }
}